import { Button } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './AlfaSecondaryMortgagePromo.css';
import imgLogo from './assets/logo.svg';

const URL =
  '/ipoteka-main?cian_source=cian&cian_medium=trap&cian_campaign=above_serp&cian_content=serp_banner_skidka_1_percent&cian_term=serp';

export const AlfaSecondaryMortgagePromo = () => {
  return (
    <a href={URL} className={styles['banner']}>
      <img className={styles['logo']} src={imgLogo} alt="Циан.Ипотека" />
      <p className={styles['title']}>Ипотека на вторичку со скидкой</p>
      <Button theme="fill_white_primary" size="XS">
        Хочу скидку
      </Button>
    </a>
  );
};
